import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { CheckCircle2Icon, AlertTriangleIcon, StarIcon } from 'lucide-react';
export function ArticleBody() {
  return <article className="space-y-10 mb-16" data-id="element-7">
      {/* PROBLEM */}
      <FadeIn data-id="element-8">
        <div className="bg-red-50 border-l-4 border-[#CC0000] p-6 rounded-r-xl max-w-3xl mx-auto shadow-sm" data-id="element-9">
          <p className="text-lg md:text-xl font-bold text-[#CC0000] leading-relaxed" data-id="element-10">
            Window quotes vary by $3,000+ depending on your zip code — most
            homeowners never compare.
          </p>
        </div>
      </FadeIn>

      {/* SOCIAL PROOF */}
      <FadeIn data-id="element-11">
        <div className="bg-gray-50 border border-gray-200 rounded-xl py-4 px-6 flex flex-col sm:flex-row items-center justify-center gap-3 max-w-3xl mx-auto" data-id="element-12">
          <div className="flex gap-1" data-id="element-13">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-14" />)}
          </div>
          <p className="text-base md:text-lg font-semibold text-[#333] text-center" data-id="element-15">
            Trusted by 47,000+ homeowners across all 50 states
          </p>
        </div>
      </FadeIn>

      {/* BENEFITS */}
      <FadeIn data-id="element-16">
        <div className="max-w-2xl mx-auto" data-id="element-17">
          <div className="space-y-4" data-id="element-18">
            {['See real prices for YOUR zip code', 'Compare 3-5 local options instantly', 'Save up to $2,000+ vs. single quotes', 'Zero obligation — 100% free'].map((benefit, i) => <div key={i} className="flex items-center gap-3 bg-white border border-gray-100 rounded-xl p-4 shadow-sm" data-id="element-19">
                <CheckCircle2Icon className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-20" />
                <span className="text-lg font-medium text-[#111]" data-id="element-21">
                  {benefit}
                </span>
              </div>)}
          </div>
        </div>
      </FadeIn>

      {/* CTA */}
      <FadeIn data-id="element-22">
        <div className="flex justify-center" data-id="element-23">
          <CTAButton data-id="element-24">Check My Local Prices Now</CTAButton>
        </div>
      </FadeIn>

      {/* URGENCY */}
      <FadeIn data-id="element-25">
        <div className="flex items-center justify-center gap-2 bg-yellow-50 border border-yellow-300 rounded-xl p-4 max-w-2xl mx-auto" data-id="element-26">
          <AlertTriangleIcon className="w-5 h-5 text-yellow-600 flex-shrink-0" data-id="element-27" />
          <p className="text-base font-semibold text-yellow-800 text-center" data-id="element-28">
            Prices updated for April 2026 — availability limited in some areas
          </p>
        </div>
      </FadeIn>
    </article>;
}